module.exports = {
  model: { id: '', name: '', value: 0, start_time: null, end_time: null, customer_id: null },
}
